import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { navigate, useLocation } from '@reach/router';
import axios from 'axios';
import moment from 'moment';
import Handlebars from "handlebars";
import { Grid, makeStyles, Button, CircularProgress, FormControlLabel, Checkbox } from '@material-ui/core';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import GoogleRecaptcha from './recaptchaButton';
import TagsNavigator from './components/tagsNavigator';
import LayoutLoading from '../layout/layoutLoading';
import QuoteContainer from './quoteContainer';

import { getWithRemote, getWithRemoteApi } from '../../actions/dynamicActions';
import { postSaveQuotation } from '../../actions/serviceActions';
import { showError } from '../../actions/notificationActions';
import { useQuote } from '../../hooks/useQuote';
import { isValidEmail } from '../../utils';
import Utils from '../../utils/utils';

import settings from '../../settings';
import { AUTOS } from '../../utils/risksTypes';

import testData from './testData.json';
import Swal from 'sweetalert2';
import { getComercialPlansLabels, getPostalCodesByState, getStateList } from '../../sevices/quoteService';

const useStyles = makeStyles((theme) => ({
    appContainer: {
        paddingLeft: 8,
        paddingRight: 8,
        width: '100%'
    },
    hide: {
        display: 'none'
    },
    loader: {
        textAlign: 'center',
        width: '100%'
    },
    button: {
        width: '100%',
    }
}));

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

const DynamicForm = ({ data, insurance, product, formBuilderId, riskType, saved, calculationType, options }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const quote = useQuote(riskType);

    const [index, setIndex] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const [fillingExtraFields, setFillingExtraFields] = useState(false);
    const [extraFields, setExtraFields] = useState([]);
    const [extraFieldsOuterIndex, setExtraFieldsOuterIndex] = useState(0);
    const [extraFieldsInnerIndex, setExtraFieldsInnerIndex] = useState(0);
    const [extraFieldsGroupIndex, setExtraFieldsGroupIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [stateList, setStateList] = useState([]);
    const [tokenRecaptcha, setTokenRecaptca] = useState('');
    const dynamicReducer = useSelector(state => state.dynamicReducer);
    const location = useLocation();

    const handleTermsChange = (event) => setTermsAccepted(event.target.checked);

    const steps = [];
    const { quotation: { quotationScreenValues } } = quote;

    let extraFieldsRetrieved = '';
    let multipleFieldsTemplate = [];

    const handleStateList = async () => {
        setLoading(true);
        const result = await getStateList();
        const mappedResult = result?.result?.result?.map(state => ({ _id: state.codigo_estado, name: state.descripcion }));
        steps.forEach((step) => {
            if (step.name === 'provincia') {
                step.options = mappedResult
            }
        });

        setStateList(mappedResult);
        setLoading(false);
        /* data.groups.map((group) => {
            const _fields = group.fields.map(field => {
                console.log(`El campo es provincia? ${field.name === 'provincia'} y va a tener options`, field.name === 'provincia' ? mappedResult : []);
                return {
                    ...field,
                    options: field.name === 'provincia' ? mappedResult : []
                }
            });

            return {
                ...group,
                fields: _fields
            };
        });
        setStateList(mappedResult); */
    };

    useEffect(() => {
        if (stateList.length == 0) {
            handleStateList();
        }
    }, []);

    data.groups.forEach((group, i) => {
        if (!group.multiple) {
            group.fields.forEach(field => {
                if (group.groupName === 'lead') {
                    steps.push({
                        ...field,
                        isLead: true
                    });
                } else {
                    steps.push(field);
                }
            });
        } else {
            if (group.min > 0) {
                steps.push({
                    value: group.min,
                    type: 'multiple',
                    groupIndex: multipleFieldsTemplate.length
                });
            }
            group.groupIndex = multipleFieldsTemplate.length;
            multipleFieldsTemplate = multipleFieldsTemplate.concat(group.fields.map(f => ({ groupName: group.groupName, ...f })));
        }
    });

    // Este codigo reconstruye la data que se necesita en sessionStorage
    // cuando se ingresa a traves del link
    if (steps.length > 0 && saved && !data.extraFields) {
        const allIsNull = steps.reduce((total, step) => step.value === null);

        if (allIsNull && quotationScreenValues && !Utils.isEmptyObject(quotationScreenValues)) {
            steps.map(step => {
                const property = step.name;
                step.value = quotationScreenValues[property];
            });

            const items = Array.isArray(quotationScreenValues.items) ? [...quotationScreenValues.items] : [];

            extraFieldsRetrieved = items.map((item) => {
                const _item = Object.assign({}, item);
                const templates = [...multipleFieldsTemplate];

                const result = templates.map((group) => {
                    return group.map((temp) => {
                        const _temp = Object.assign({}, temp);
                        const property = _temp.name;
                        if (_temp.groupName === _item.groupName) {
                            _temp.value = _item[property];
                        }
                        return _temp;
                    });
                });

                return result;
            });

            data.extraFields = extraFieldsRetrieved;
            sessionStorage.setItem(`quotation::${riskType}`, JSON.stringify(data));
            setExtraFields(data.extraFields);
            setIndex(steps.length - 1);
        }
    }

    useEffect(() => {
        if (saved) {
            const lastTag = steps[steps.length - 1];
            if (lastTag.controlType !== 'chip') {
                setInputValue(lastTag.value);
            }
            if (data.extraFields) {
                setExtraFields(data.extraFields);
            }
            setIndex(steps.length - 1);
        } else {
            let initialExtraFields = [];
            data.groups.filter(g => g.multiple).forEach(_ => {
                initialExtraFields.push([]);
            });
            setExtraFields(initialExtraFields);
        }
    }, [saved]);

    const extraFieldsValid = (groups) => {
        return extraFields.filter((_, i) => groups[i].min > 0).every((eF, i) => eF.length >= groups[i].min);
    }

    const isValid = () => {
        let conditions = steps.filter(step => !step.isLead && step.type !== 'multiple').every(step => step.value !== null);
        let recaptcha = true;
        if (steps.find(step => step.isLead)) {
            conditions = conditions && isValidEmail(inputValue);
        }

        const multipleGroups = data.groups.filter(g => g.multiple);
        const isRequired = multipleGroups.some(group => group.min > 0);
        if (multipleGroups && isRequired) {
            conditions = conditions && extraFieldsValid(multipleGroups);
        }

        if (options && options.recaptcha && !tokenRecaptcha){
            recaptcha = false;
        }
        return conditions && termsAccepted && recaptcha;
    };

    const handleCloseTag = async (tag) => {
        const tagIndex = steps.findIndex(s => s.name === tag.name);
        const multiGroupIndex = steps.findIndex(s => s.type === 'multiple');
        steps.map(step => {
            const _step = step;
            if (tagIndex <= _step.order) {
                if (_step.name === 'plate') {
                    _step.value = '';
                } else {
                    _step.value = null;
                }
                if ((_step.remote && typeof _step.remote === 'string') || _step.remote && _step.remote.url) {
                    _step.options = [];
                }
            }

            return _step;
        });

        if ((steps[tagIndex].remote && typeof steps[tagIndex].remote === 'string') || steps[tagIndex].remote && steps[tagIndex].remote.url) {
            const dependencies = steps[tagIndex].dependency.map(dependency => {
                const dependencyField = steps.find(step => step.name === dependency);

                return dependencyField.value;
            });
            const remote = getFormattedRemoteUrl(steps[tagIndex], dependencies);

            // await dispatch(getWithRemote(remote.url, remote.external));
            setLoading(true);
            const result = steps[tagIndex].name == 'provincia' ? stateList : await getWithRemoteApi(remote.url, remote.external);
            setLoading(false);
            if (steps[tagIndex].remote) {
                steps[tagIndex].options = result.data ? result.data : result;
            }
        }
        // steps[currenttagIndex].options = dynamicReducer.data;

        if (tag.controlType !== 'chip') {
            setInputValue(tag.value);
        }
        setIndex(tagIndex);
        if (tagIndex < multiGroupIndex) {
            setExtraFieldsInnerIndex(0);
            const updatedExtraFieldGroup = extraFields.map((curr, i) => {
                if (i === steps[multiGroupIndex].groupIndex) {
                    return [];
                }

                return curr;
            })
            setExtraFields(updatedExtraFieldGroup);
        }
    };

    const handleCheck = async (value, extraField) => {
        if (!extraField) {
            if (steps[index].remote && steps[index].remote.includes('plate')) {
                if (value !== '') {
                    try {
                        const response = await axios.get(`${settings.quotationUrlApi}${steps[index].remote}/${value}`);
                        const data = response.data.data;
                        const mappedSteps = steps.map(step => {
                            const _step = step;
                            if (Object.keys(data).find(d => d === step.name) !== undefined) {
                                _step.value = data[step.name];
                            };

                            return _step;
                        });

                        steps[index].value = value;
                        setInputValue('');
                        setIndex(index + (Object.keys(data).length + 1));
                    } catch (error) {
                        dispatch(showError(error.response.data.data));
                    }
                } else {
                    steps[index].value = '';
                    setInputValue('');
                    setIndex(index + 1);
                }
            } else {
                steps[index].value = value;
                setInputValue('');
                setIndex(index + 1);
            }
        } else {
            const currentExtraFieldGroup = extraFields[extraFieldsGroupIndex];
            const currentField = currentExtraFieldGroup[extraFieldsOuterIndex];
            const currentTag = currentField[extraFieldsInnerIndex];
            currentTag.value = value;
            const updatedExtraFieldGroup = currentExtraFieldGroup.map((eF, i) => {
                if (i === extraFieldsOuterIndex) {
                    const tags = eF.map((t, i) => {
                        if (i === extraFieldsInnerIndex) {
                            return currentTag;
                        }
                        return t;
                    });

                    return tags;
                }

                return eF;
            });

            setInputValue('');
            if (currentField.length > extraFieldsInnerIndex + 1) {
                setExtraFieldsInnerIndex(extraFieldsInnerIndex + 1);
            } else {
                setFillingExtraFields(false);
                setExtraFieldsInnerIndex(0);
                if (steps[index].type === 'multiple' && (updatedExtraFieldGroup.length >= steps[index].value)) {
                    setIndex(index + 1);
                }
            }

            const updatedExtraFields = extraFields.map((ex, i) => {
                if (i === extraFieldsGroupIndex) {
                    return updatedExtraFieldGroup
                }

                return ex;
            });
            setExtraFields(updatedExtraFields);
        }
    };

    const handleSelect = async (value, extraField) => {
        if (!extraField) {
            const currentTag = steps.find((step, i) => i === index);
            if (steps[index + 1] && ((steps[index + 1].remote && typeof steps[index + 1].remote === 'string') || steps[index + 1].remote && steps[index + 1].remote.url)) {
                const dependencies = steps[index + 1].dependency.map(dependency => {
                    const dependencyField = steps.find(step => step.name === dependency);

                    return dependencyField.value === null ? value : dependencyField.value;
                });
                const remote = getFormattedRemoteUrl(steps[index + 1], dependencies);

                //await dispatch(getWithRemote(remote.url, remote.external));
                setLoading(true);
                const result = await getWithRemoteApi(remote.url, remote.external);
                setLoading(false);
                if (steps[index + 1].remote) {
                    steps[index + 1].options = result.data ? result.data : result;
                }
            }

            /* if (steps[index + 1] && !steps[index + 1].remote && steps[index].remote) {
                steps[index].options = dynamicReducer.data;
            } */

            if (currentTag.controlType === 'chip') {
                steps[index].value = value;
                setIndex(index + 1);
            } else {
                setInputValue(value);
            }
        } else {
            const currentExtraFieldGroup = extraFields[extraFieldsGroupIndex];
            const currentField = currentExtraFieldGroup[extraFieldsOuterIndex];
            const currentTag = currentField[extraFieldsInnerIndex];
            const nextTag = currentField[extraFieldsInnerIndex + 1];
            if (nextTag && ((nextTag.remote && typeof nextTag.remote === 'string') || nextTag.remote && nextTag.remote.url)) {
                const dependencies = nextTag.dependency.map(dependency => {
                    const allFields = steps.slice().concat(...currentExtraFieldGroup);
                    const dependencyField = allFields.find(step => step.name === dependency);

                    return dependencyField.value === null ? value : dependencyField.value;
                });
                const remote = getFormattedRemoteUrl(nextTag, dependencies);
                // `${typeof nextTag.remote === 'string' ? nextTag.remote : nextTag.remote?.url}${dependencies}`;
                setLoading(true);
                const result = await getWithRemoteApi(remote.url, remote.external);
                setLoading(false);
                if (nextTag.remote) {
                    nextTag.options = result.data ? result.data : result;
                }
            }

            if (currentTag.controlType === 'chip') {
                currentTag.value = value;
                const updatedExtraFieldGroup = currentExtraFieldGroup.map((eF, i) => {
                    if (i === extraFieldsOuterIndex) {
                        const tags = eF.map((t, i) => {
                            if (i === extraFieldsInnerIndex) {
                                return currentTag;
                            }
                            return t;
                        });

                        return tags;
                    }

                    return eF;
                });

                if (currentField.length > extraFieldsInnerIndex + 1) {
                    setExtraFieldsInnerIndex(extraFieldsInnerIndex + 1);
                } else {
                    setFillingExtraFields(false);
                    setExtraFieldsInnerIndex(0);
                    if (steps[index].type === 'multiple' && (updatedExtraFieldGroup.length >= steps[index].value)) {
                        setIndex(index + 1);
                    }
                }

                const updatedExtraFields = extraFields.map((ex, i) => {
                    if (i === extraFieldsGroupIndex) {
                        return updatedExtraFieldGroup
                    }

                    return ex;
                });

                setExtraFields(updatedExtraFields);
            } else {
                setInputValue(value);
            }
        }
    };

    const getFormattedValue = (field) => {
        switch (field.dataType) {
            case 'bool':
            case 'object':
            case 'array':
            case 'string': return field.value;
            case 'numeric':
                let value = field.value;
                if (isNaN(value)) {
                    value = value.includes(',') ? value.replaceAll(',', '') : value
                }
                return Number(value);
            case 'date': case 'birthdate': return field.controlType.includes('birthdate') ? moment().diff(field.value, 'years') : field.value;
        };
    };

    const getFormattedRemoteUrl = (field, dependencies) => {
        if (typeof field.remote === 'string') {
            return {
                url: `${field.remote}${dependencies.join('/')}`,
                external: false
            };
        }

        if (field.remote.external) {
            const _dependencies = {};
            dependencies.forEach((d, i) => {
                _dependencies[field.dependency[i]] = d;
            });

            const formattedUrl = Handlebars.compile(field.remote.url.replace(/\$/g, ""))(_dependencies);

            return {
                url: formattedUrl,
                external: true
            };
        }

        return {
            url: `${field.remote.url}${dependencies.join('/')}`,
            external: false
        };
    };

    const buildQuoteBody = () => {
        const quoteBody = {};

        steps.filter(step => !step.isLead && step.type !== 'multiple').forEach(step => {
            if ((step.remote && typeof step.remote === 'string') || step.remote && step.remote.url) {
                const selectedOption = step.options.find(opt => opt._id === step.value);
                quoteBody[step.name] = selectedOption !== undefined ? selectedOption.name : step.value;
            } else {
                quoteBody[step.name] = getFormattedValue(step);
                if (step.controlType.includes('birthdate')) {
                    quoteBody[`${step.name}_birthdate`] = getFormattedValue({ ...step, dataType: 'date', controlType: 'date' })
                }
            }
        });

        quoteBody.riskType = data.riskType;
        quoteBody.insuranceId = insurance;
        quoteBody.quotas = [3, 6, 9];

        if (typeof quoteBody.ano === 'boolean' && riskType.toUpperCase() === AUTOS) {
            quoteBody.producto = quoteBody.ano === true ? 'Todo Riesgo' : 'Perdida Total';
        }

        quoteBody.items = extraFields.map((g) => {
            const mappedFields = g.map((f, i) => {
                const obj = {};
                f.forEach(_f => {
                    if (((_f.remote && typeof _f.remote === 'string') || _f.remote && _f.remote.url) && _f.dataType !== 'numeric') {
                        const selectedOption = _f.options.find(opt => opt._id === _f.value);
                        obj[_f.name] = selectedOption !== undefined ? selectedOption.name : _f.value;
                    } else {
                        obj[_f.name] = getFormattedValue(_f);
                        if (_f.controlType.includes('birthdate')) {
                            obj[`${_f.name}_birthdate`] = getFormattedValue({ ..._f, dataType: 'date', controlType: 'date' });
                        }
                    }
                    obj.groupName = _f.groupName;
                });

                obj.qItem = extraFields.reduce((prev, curr) => prev += curr.length, 0);

                if (obj.vehicleType) {
                    obj.vehicleType = obj.vehicleType.includes('Heavy') ? 'HeavyTruck' : 'LightTruck';
                }

                return obj;
            });

            return mappedFields;
        }).reduce((prev, curr) => prev = prev.concat(...curr), [])

        const leadField = steps.find(step => step.isLead);

        quoteBody.lead = inputValue;

        quoteBody.calculationType = calculationType;

        return {
            lead: leadField !== undefined ? { email: inputValue } : null,
            item: {...quoteBody,
                "year": 2015,
                "brand": "ALFA ROMEO",
                "model": "146 BERLINA"
              
            }
        };
    };

    const getDescription = (key, value) => {
        const field = steps.find(f => f.name === key);

        if (field) {
            const option = field.options.find(opt => opt._id == value);
            if (option)
                return option.name;
        }


        return value;
    };

    const buildLibraQuoteBody = async () => {
        const quoteBody = {};
        const innerQuoteBody = {}

        steps.filter(step => !step.isLead && step.type !== 'multiple').forEach(step => {
            if (step.name == 'Modelo') {
                const selectedModel = step.options.find(opt => opt._id == step.value);
                innerQuoteBody.tipo = selectedModel?.descripcion_tipo;
                innerQuoteBody.Origen = selectedModel?.descripcion_origen;
                innerQuoteBody.Valor = selectedModel?.precio;
                innerQuoteBody.ClausulaAjuste = 3;
                innerQuoteBody.Uso = 1;
            }

            innerQuoteBody[step.name] = getFormattedValue(step);
        });

        quoteBody.riskType = data.riskType;
        quoteBody.insuranceId = insurance;
        quoteBody.quotas = [3, 6, 9];

        if (typeof quoteBody.ano === 'boolean' && riskType.toUpperCase() === AUTOS) {
            quoteBody.producto = quoteBody.ano === true ? 'Todo Riesgo' : 'Perdida Total';
        }

        quoteBody.items = extraFields.map((g) => {
            const mappedFields = g.map((f, i) => {
                const obj = {};
                f.forEach(_f => {
                    if (((_f.remote && typeof _f.remote === 'string') || _f.remote && _f.remote.url) && _f.dataType !== 'numeric') {
                        const selectedOption = _f.options.find(opt => opt._id === _f.value);
                        obj[_f.name] = selectedOption !== undefined ? selectedOption.name : _f.value;
                    } else {
                        obj[_f.name] = getFormattedValue(_f);
                        if (_f.controlType.includes('birthdate')) {
                            obj[`${_f.name}_birthdate`] = getFormattedValue({ ..._f, dataType: 'date', controlType: 'date' });
                        }
                    }
                    obj.groupName = _f.groupName;
                });

                obj.qItem = extraFields.reduce((prev, curr) => prev += curr.length, 0);

                if (obj.vehicleType) {
                    obj.vehicleType = obj.vehicleType.includes('Heavy') ? 'HeavyTruck' : 'LightTruck';
                }

                return obj;
            });

            return mappedFields;
        }).reduce((prev, curr) => prev = prev.concat(...curr), [])

        const leadField = steps.find(step => step.isLead);

        quoteBody.lead = inputValue;

        quoteBody.calculationType = calculationType;

        const quoteData = testData;

        const postalCodes = await getPostalCodesByState(innerQuoteBody.provincia);
        const municipality = postalCodes.find(p => p.codigo_postal === innerQuoteBody.cp);
        if (municipality) {
            quoteData.Municipio = municipality.cod_municipio || 1;
            quoteData.Calle = municipality.calle;
        } else {
            return false;
        }
        quoteData.Provincia = innerQuoteBody.provincia;
        quoteData.DescProvincia = stateList.find(s => s._id === innerQuoteBody.provincia)?.name;

        quoteData.CodPostal = innerQuoteBody.cp;
        quoteData.Ramo = riskType.toLowerCase().includes('auto') ? 4 : 24;
        const comercialPlans = await getComercialPlansLabels(quoteData.CodAgente, quoteData.TipoVigencia, quoteData.Ramo);
        if (product) {
            if (typeof product == 'object')
                quoteData.ListaPlanesComerciales = product.map(p => Number(p));
            else
                quoteData.PlanComercial = Number(product);
        } else {
            return false;
        }
        const now = moment();
        const tomorrow = moment().add('1', 'd');
        quoteData.VigenciaDesde = now.isAfter(moment({ hour: 12, minute: 0 })) ? tomorrow.clone().set({ h: 12, m: 0, s: 0 }).format('YYYY-MM-DD HH:mm:ss') : now.clone().set({ h: 12, m: 0, s: 0 }).format('YYYY-MM-DD HH:mm:ss');
        quoteData.VigenciaHasta = (now.isAfter(moment({ hour: 12, minute: 0 })) ? tomorrow : now).clone().set({ h: 12, m: 0, s: 0 }).add(3, 'months').format('YYYY-MM-DD HH:mm:ss');
        quoteData.RiesgosPorRamo = [];
        quoteData.RiesgosPorRamo = quoteData.RiesgosPorRamo.concat({
            ...innerQuoteBody
        });
        quoteBody.quoteData = quoteData;
        return {
            recaptcha: options.recaptcha,
            tokenRecaptcha,
            lead: leadField !== undefined ? { email: inputValue } : null,
            item: {
                ...quoteBody,
                rysk: quoteBody.riskType,
                titular: "Asegurado",
                agent: "0-0-4-4378",
                validity: "TRIMESTRAL",
                nameAgent: "COTIZADOR DIRECTO",
                fiscalConditionName: "CONSUMIDOR FINAL",
                payment: "TARJETA DE CRÉDITO",
                location: quoteData.Calle,
                postalCode: quoteData.CodPostal,
                street: "No Asignada",
                provinceName: quoteData.DescProvincia,
                PlanComercialName: quoteData.PlanComercial ?
                    comercialPlans
                        .find(c => c.ProductCode === quoteData.PlanComercial)?.Description :
                    quoteData.ListaPlanesComerciales
                        .map(lpc => comercialPlans.find(c => c.ProductCode === lpc)?.Description).join(', '),
                detailsItems: [],
                detailsValues: {
                    ClausulaAjuste: '20%',
                    AnioVehiculo: innerQuoteBody.AnioVehiculo,
                    Marca: getDescription('Marca', innerQuoteBody.Marca),
                    Modelo: getDescription('Modelo', innerQuoteBody.Modelo),
                    Uso: "Particular"
                },
                phone: innerQuoteBody.telefono,
                email: inputValue
            }
        };
    };

    const saveQuotation = () => {
        const _data = data;
        _data.groups = data.groups.map(group => {
            const _group = group;
            if (!_group.multiple) {
                _group.fields.map(field => {
                    const _field = field;

                    _field.value = steps.filter(step => step.type !== 'multiple').find(step => step._id === _field._id).value;

                    return _field;
                });
            }
            return _group;
        });

        _data.extraFields = extraFields;
        sessionStorage.setItem(`quotation::${riskType}`, JSON.stringify(_data));
    };

    const handleGoToTerms = () => {
        window.open(settings.redirectConfirm || 'https://libraseguros.com.ar/terminos-y-condiciones/', '_blank');
    };

    const proceed = async () => {
        setLoading(true);
        const quoteBody = calculationType === 'libra' ? await buildLibraQuoteBody() : await buildQuoteBody();
        if (!quoteBody) {
            Toast.fire({
                icon: 'error',
                title: 'Verifique la provincia y el código postal'
            });
            setLoading(false);
            return;
        }

        const resultQuote = await dispatch(postSaveQuotation(quoteBody, riskType));
        if (resultQuote.isAxiosError) {
            Toast.fire({
                icon: 'error',
                title: 'Ha ocurrido un error con el servicio'
            });
            setLoading(false);
            return;
        }
        saveQuotation();
        sessionStorage.setItem(`quotation::quote::${riskType}`, JSON.stringify({ plan: {}, quotation: resultQuote }));
        localStorage.setItem('quotation::id', resultQuote._id);
        setLoading(false);
        if (location.pathname.includes('embed')) {
            navigate(`/embed/quote/${riskType.toLowerCase()}/${data._id}/${insurance}/${formBuilderId}/${resultQuote._id}/proposal`);
        } else {
            navigate(`/quote/${riskType.toLowerCase()}/${data._id}/${insurance}/${formBuilderId}/${resultQuote._id}/proposal`);
        }
    };

    const handleFillExtraFields = (index) => {
        if (fillingExtraFields) {
            const updatedExtraFieldGroup = extraFields.map((curr, i) => {
                if (i === extraFieldsGroupIndex) {
                    return curr.slice(0, -1);
                }

                return curr;
            });
            setExtraFields(updatedExtraFieldGroup);
            setFillingExtraFields(false);
        } else {
            const group = data.groups.filter(gr => gr.multiple);
            const fields = group[index].fields.map(f => ({
                ...f,
                groupName: group[index].groupName,
                value: null
            }));
            const updatedExtraFieldGroup = extraFields.map((curr, i) => {
                if (i === index) {
                    return curr.concat([fields]);
                }

                return curr;
            })
            setInputValue('');
            setExtraFields(updatedExtraFieldGroup);
            setExtraFieldsGroupIndex(index);
            setExtraFieldsOuterIndex(extraFields[index].length);
            setFillingExtraFields(true);
        }
    };

    const handleDeleteExtraField = (index, groupIndex) => {
        const currentGroup = extraFields[groupIndex];
        if (fillingExtraFields) {
            setExtraFieldsInnerIndex(0);
            const updatedFields = currentGroup.map((f, i) => {
                if (i === index) {
                    return f.map((_f) => {
                        return {
                            ..._f,
                            value: null
                        };
                    });
                }

                return f;
            });
            const updatedExtraFieldGroup = extraFields.map((curr, i) => {
                if (i === groupIndex) {
                    return updatedFields;
                }

                return curr;
            })
            setExtraFields(updatedExtraFieldGroup);
        } else {
            const updatedExtraFieldGroup = extraFields.map((curr, i) => {
                if (i === groupIndex) {
                    return curr.filter((c, j) => j !== index);
                }

                return curr;
            })
            setExtraFields(updatedExtraFieldGroup);
        }
    };

    const handleDeleteExtraFieldTag = (index, groupIndex, innerIndex) => {
        const updatedExtraFieldsGroup = extraFields.map((curr, i) => {
            if (i === groupIndex) {
                return curr.map((group, j) => {
                    if (j === index) {
                        return group.map((field, k) => {
                            const _field = field;

                            if (k > (innerIndex + 1)) {
                                if ((_field.remote && typeof _field.remote === 'string') || _field.remote && _field.remote.url) {
                                    _field.options = _field.options.some(opt => opt.main) ? _field.options.filter(opt => opt.main) : [];
                                }
                            }

                            if (k >= (innerIndex + 1)) {
                                _field.value = null;
                            }

                            return _field;
                        });
                    };

                    return group;
                })
            }

            return curr;
        });
        setExtraFields(updatedExtraFieldsGroup);
        setExtraFieldsGroupIndex(groupIndex);
        setExtraFieldsOuterIndex(index);
        setExtraFieldsInnerIndex(innerIndex);
        setFillingExtraFields(true);
    };
    const currentGroup = extraFields[extraFieldsGroupIndex];

    if (dynamicReducer.isFetching || loading) return <LayoutLoading />;
    return (
        <Grid container justify="center" className={classes.appContainer}>
            <Grid item xs={12} sm={9} md={7} className="cardAppContainer">
                <TagsNavigator
                    classes={classes}
                    index={index}
                    groups={data.groups}
                    handleCloseTag={handleCloseTag}
                    handleFillExtraFields={handleFillExtraFields}
                    fillingExtraFields={fillingExtraFields}
                    extraFields={extraFields}
                    handleDeleteExtraField={handleDeleteExtraField}
                    handleDeleteExtraFieldTag={handleDeleteExtraFieldTag}
                    currentGroupIndex={extraFieldsGroupIndex} />
                {(steps[index] && steps[index].type !== 'multiple') &&
                    <>
                        {!fillingExtraFields && (
                            <QuoteContainer
                                handleSelect={handleSelect}
                                handleCheck={handleCheck}
                                name={steps[index].name}
                                label={steps[index].label}
                                dataType={steps[index].dataType}
                                controlType={steps[index].controlType}
                                options={steps[index].options}
                                data={dynamicReducer.data}
                                isLast={!steps[index + 1]}
                                value={inputValue}
                                validations={steps[index].validations}
                                mask={steps[index].mask}
                                isSearchable={steps[index].isSearchable}
                                quotationScreenOptions={data.options}
                            />
                        )}
                    </>
                }

                {fillingExtraFields && (
                    <QuoteContainer
                        handleSelect={(value) => handleSelect(value, true)}
                        handleCheck={(value) => handleCheck(value, true)}
                        name={currentGroup[extraFieldsOuterIndex][extraFieldsInnerIndex].name}
                        label={currentGroup[extraFieldsOuterIndex][extraFieldsInnerIndex].label}
                        dataType={currentGroup[extraFieldsOuterIndex][extraFieldsInnerIndex].dataType}
                        controlType={currentGroup[extraFieldsOuterIndex][extraFieldsInnerIndex].controlType}
                        options={currentGroup[extraFieldsOuterIndex][extraFieldsInnerIndex].options}
                        data={dynamicReducer.data}
                        value={inputValue}
                        validations={currentGroup[extraFieldsOuterIndex][extraFieldsInnerIndex].validations}
                        mask={currentGroup[extraFieldsOuterIndex][extraFieldsInnerIndex].mask}
                        isSearchable={currentGroup[extraFieldsOuterIndex][extraFieldsInnerIndex].isSearchable}
                        quotationScreenOptions={data.options}
                    />)}
                {!fillingExtraFields ? (
                    <Grid container direction="column" style={{ justifyContent: 'center', alignItems: 'center' }} className="contentForm">
                        {index == steps.length - 1 && <Grid item>
                            <Button
                                className={classes.button}
                                variant="outlined"
                                color="primary"
                                onClick={() => handleGoToTerms()}
                            >
                                Términos y condiciones
                            </Button>

                            <div className="terms-container">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            onChange={
                                                handleTermsChange
                                            }
                                            checked={termsAccepted}
                                        />
                                    }
                                    label="Acepto los términos y condiciones"
                                />
                            </div>
                            {
                                options && options.recaptcha &&
                                <GoogleReCaptchaProvider 
                                    useRecaptchaNet
                                    reCaptchaKey={options && options.recaptchaPublicKey}
                                    scriptProps={{ async: true, defer: true, appendTo: 'body' }}
                                >
                                    <GoogleRecaptcha setTokenRecaptca = {setTokenRecaptca} tokenRecaptcha={tokenRecaptcha}/>
                                </GoogleReCaptchaProvider>
                            }
                        </Grid>} 

                        {
                            isValid() &&
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={proceed}
                                disabled={!isValid()}
                            >
                                COTIZAR
                            </Button>
                        }
                    </Grid>
                ) : (
                    <Grid container style={{ justifyContent: 'flex-end' }} className="contentForm">
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleFillExtraFields}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                )}
                {loading
                    ? <div className={classes.loader}>
                        <CircularProgress color="primary" />
                    </div> : ''}
            </Grid>
        </Grid>
    );
};

export default DynamicForm;
